import React from 'react'
import { useEffect } from 'react'
import { useGlobalState } from 'state'
import { LAYERS } from 'common/layers'

export const KouzuiNomalRiverLineLayer = () => {
  const state = useGlobalState()
  const layerIds = [
    LAYERS.KOUZUI_NORMAL_RIVER_LABEL.id,
    LAYERS.KOUZUI_NORMAL_RIVER_LINE.id
  ]

  useEffect(() => {
    if (!state.mapbox) return
    layerIds.forEach(layerId => {
      state.map.setLayoutVisibility(layerId, true)
    })

    return () => {
      layerIds.forEach(layerId => {
        state.map.setLayoutVisibility(layerId, false)
      })
    }
  }, [state.mapbox])

  return <></>
}
